import { render, staticRenderFns } from "./AmsProductPage.vue?vue&type=template&id=b329ee32"
import script from "./AmsProductPage.vue?vue&type=script&lang=js"
export * from "./AmsProductPage.vue?vue&type=script&lang=js"
import style0 from "./AmsProductPage.vue?vue&type=style&index=0&id=b329ee32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports